import { useState } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { useLoggedInUser } from "../../../../utils/logged-in-user-provider";

import { Divider } from "./icons/divider";
import { MobileNavLinks } from "./mobile-nav-links-container";
import { MobileNavProductEveryone } from "./mobile-nav-product-everyone";
import { MobileNavTop } from "./mobile-nav-top";

const containerCss = css({
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: token("space.150")
});

const containerClosedCss = css({
    padding: "8px"
});

const containerOpenCss = css({
    height: "100vh",
    width: "100%",
    overflow: "auto",
    position: "fixed",
    insetBlockStart: "0",
    padding: "8px 24px 24px 24px",
    zIndex: "5"
});

const navBarClosedCss = css({
    paddingInline: token("space.200"),
    display: "flex",
    justifyContent: "space-between"
});

const navBarOpenCss = css({
    display: "flex",
    justifyContent: "space-between"
});

const fadeInCss = css({
    "@keyframes fadeIn": {
        from: {
            opacity: "0"
        },
        to: {
            opacity: "1"
        }
    },
    "opacity": "0",
    "animation": "0.5s ease-in fadeIn 200ms forwards"
});

export type DropdownType =
    | "default"
    | "product-everyone"
    | "product-developer"
    | "product-project-managers"
    | "product-it-professionals"
    | "teams"
    | "why-atlassian"
    | "resources";

export type MobileGlobalNavProps = {
    productKey: ProductKeyTypes;
};

export const MobileGlobalNav = ({ productKey }: MobileGlobalNavProps) => {
    const { isUserLoggedIn, name, picture } = useLoggedInUser();
    const [showMenu, setShowMenu] = useState(false);

    const [menuPage, setMenuPage] = useState<DropdownType>("default");

    const handleToggleMenu = (showMenu: boolean) => {
        setShowMenu(showMenu);
    };

    const handleMenuPage = (menuPage: DropdownType) => {
        setMenuPage(menuPage);
    };

    return (
        <div
            css={[
                containerCss,
                showMenu ? containerOpenCss : containerClosedCss
            ]}
        >
            <div css={[showMenu ? navBarOpenCss : navBarClosedCss]}>
                <MobileNavTop
                    productKey={productKey}
                    isLoggedIn={isUserLoggedIn}
                    userName={name}
                    picture={picture}
                    showMenu={showMenu}
                    handleToggleMenu={handleToggleMenu}
                    menuPage={menuPage}
                    handleMenuPage={handleMenuPage}
                />
            </div>
            {showMenu && (
                <>
                    <div>
                        <Divider />
                    </div>
                    {menuPage === "default" && (
                        <div css={fadeInCss}>
                            <MobileNavLinks
                                isLoggedIn={isUserLoggedIn}
                                handleMenuPage={handleMenuPage}
                            />
                        </div>
                    )}
                    {menuPage === "product-everyone" && (
                        <div css={fadeInCss}>
                            <MobileNavProductEveryone />
                        </div>
                    )}
                    {menuPage === "product-developer" && (
                        <div css={fadeInCss}>Product Developer</div>
                    )}
                    {menuPage === "product-project-managers" && (
                        <div css={fadeInCss}>Product Project Managerse</div>
                    )}
                    {menuPage === "product-it-professionals" && (
                        <div css={fadeInCss}>Product IT Professionals</div>
                    )}
                    {menuPage === "teams" && (
                        <div css={fadeInCss}>Product Teams</div>
                    )}
                    {menuPage === "why-atlassian" && (
                        <div css={fadeInCss}>Product Why Atlassian</div>
                    )}
                    {menuPage === "resources" && (
                        <div css={fadeInCss}>Product Resources</div>
                    )}
                </>
            )}
        </div>
    );
};
